import { Outlet, Link, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  AppBar,
  Typography,
  Box,
  useMediaQuery,
  IconButton,
  SwipeableDrawer,
  Avatar,
  ListSubheader,
  Button,
  ButtonBase,
  Icon,
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import { useContext, useState } from "react";
import { LOGIN_PAGE_CUSTOMER, logout } from "../api/auth";
import { GlobalContext } from "../globalComponents/context";
import { FCol } from "../globalComponents/standard";

const menuItems = [
  // { text: "Listar usuários", path: "./users" },
  // { text: "Listar clientes", path: "./customers" },
  // { text: "Painel do cliente", path: "./customerPanel" },
];

export default function Layout({ user }) {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { showConfirmDialog } = useContext(GlobalContext);

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  const handleLogout = () => {
    showConfirmDialog({
      title: "Logout",
      description: "Deseja mesmo sair?",
      onConfirm: () => logout(LOGIN_PAGE_CUSTOMER),
    });
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed" sx={{ zIndex: 1201 }}>
        <Toolbar>
          <Avatar
            component={ButtonBase}
            onClick={handleDrawerToggle}
            src="/logo-fideliza.png"
            sx={{
              border: "2px solid #fff",
              elevation: 3,
              background: "#fff",
            }}
          >
            <Icon>person</Icon>
          </Avatar>
          &nbsp;
          <Typography
            style={{ lineHeight: 1 }}
            color="secondary"
            variant="h6"
            noWrap
            flexGrow={1}
          >
            Painel do Cliente
            <br />
            <small style={{ fontStyle: "italic", color: "#fff" }}>
              {user.name}
            </small>
          </Typography>
          <Button onClick={handleLogout} color="inherit">
            Sair
          </Button>
        </Toolbar>
      </AppBar>

      {/* Temporary Drawer for mobile */}
      <SwipeableDrawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        onOpen={() => {}}
        sx={{
          //display: { xs: "block", sm: "none" }, // Only show on mobile
          width: isMobile ? 320 : 520,
        }}
      >
        <Toolbar />
        <List subheader={<ListSubheader>Opções</ListSubheader>}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.text}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={handleDrawerToggle} // Close drawer on click
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
          <ListItemButton onClick={handleLogout}>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </List>
      </SwipeableDrawer>

      {/* <Drawer
        variant="permanent"
        sx={{
          width: 320,
          [`& .MuiDrawer-paper`]: { width: 320, boxSizing: "border-box" },
          display: { xs: "none", sm: "block" }, // Hide on mobile
        }}
      >
        <Toolbar />
        <List subheader={<ListSubheader>Rotinas do sistema</ListSubheader>}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.text}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
          <ListItemButton onClick={handleLogout}>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </List>
      </Drawer> */}

      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0, // 🔥 critical fix
          padding: 0,
          height: "100vh",
          background: "#faf8f7",
          overflow: "auto", // optional but recommended
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
